<ion-header class="ion-no-border ion-padding">
  <div class="modal-state-header">
    <img
     *ngIf="!!logoUrl"
     class="modal-state-header-logo"
     [src]="logoUrl"
     [attr.alt]="'intro_state' | ariaLabel | translate"
     role="img"
     aria-live="assertive"
     [attr.aria-label]="'intro_state' | ariaLabel | translate"/>
    <ion-button
     [attr.aria-label]="'btn_modal_close'| ariaLabel | translate"
     [appAriaButton]="'btn_modal_close' | ariaLabel | translate"
     fill="clear" (click)="close()"
     class="btn-close">
      <ion-icon slot="icon-only" src="assets/icons/cross.svg"> </ion-icon>
    </ion-button>
  </div>
</ion-header>
<ion-content class="full-bg">
  <div class="modal-state-content">
    <div class="modal-state-wizard">
      <app-wizard-widget></app-wizard-widget>
    </div>

    <div class="modal-state-help" *ngIf="activeHelps.length > 0">
      <ion-card class="hint ion-margin keep-size">
        <ion-card-header>
          <ion-card-title [attr.aria-label]="'need_help' | ariaLabel | translate">{{ 'lbl.need_help' | translate }}</ion-card-title>
        </ion-card-header>
        <ion-card-content>
          <ion-item *ngFor="let code of activeHelps" lines="none" color="transparent">
            <ion-icon aria-hidden="true" class="secondary-icon" [src]="code | srcAssets:'icons'" slot="start"></ion-icon>
            <ion-label class="ion-text-wrap">
              <a [attr.aria-label]="code | ariaLabel | translate" href="javascript:void(0)" class="link" (click)="helpService.openLink(code)">
                {{('lbl.help_' + code + '_link')|translate}}
              </a>
              <p aria-hidden="true" [innerHTML]="('lbl.help_' + code + '_description')|translate"></p>
            </ion-label>
          </ion-item>
        </ion-card-content>
      </ion-card>
    </div>
  </div>
</ion-content>
